require('./appDownloadWidget.scss');

//@vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { OKMobileStoreButton } = require('commonsComponents/OKMobileStoreButton');
const { ContentBox } = require('commonsComponents/contentBox');
const withContactCenterValidation = require('utilities/withContactCenterValidation');
const { OKLink } = require('commonsComponents/OKLink');

const AppDownloadWidget = () => {
    const appleStoreLink = formatText('app-appleStore')
    const googlePlayLink = formatText('app-googlePlay')
    return (
        <ContentBox
            id="appDownloadWidget"
            customClassName="app-download-widget"
        >
            <div className="app-download-widget__text">
                <FormattedText value="widgets-downloadAppText" />
            </div>
            <div className="app-download-widget__buttons">
                <div className="app-download-widget__app-store-button">
                    <OKLink target="_blank" to={appleStoreLink}>
                        <OKMobileStoreButton modifier="app-store" />
                    </OKLink>
                </div>
                <div className="app-download-widget__google-play-button">
                    <OKLink target="_blank" to={googlePlayLink}>
                        <OKMobileStoreButton modifier="google-play" />
                    </OKLink>
                </div>
            </div>
        </ContentBox>
    );
};

module.exports = withContactCenterValidation(AppDownloadWidget)
